<script>
import { Page } from '@/api'
import PageFormBase from '@/crudBases/form/PageFormBase'
import fields from '@/components/fields/'

export default {
  extends: PageFormBase,
  data() {
    return {
      redirectRoute: { name: 'Pages List' },
      livePreview: true
    }
  },
  methods: {
    getGeneralFields() {
      return [
        new fields.Input({
          label: 'Tytuł',
          modelPath: [this, 'form', 'title'],
          multilingual: true
        }),
        new fields.Image({
          label: 'Zdjęcie',
          modelPath: [this, 'form', 'image'],
          multilingual: true,
          copyTo: { og_image: { stripHtml: false } }
        }),
        new fields.Switch({
          label: 'Ukryta',
          modelPath: [this, 'form', 'is_hidden']
        })
      ]
    }
  },
  computed: {
    service() {
      return Page
    },
    livePreviewUrl() {
      return this.form.slug_pl === 'home' ? '/preview/' : '/preview/slug/'
    }
  }
}
</script>
